export default function EmotionalSupportSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Compassionate <span className="text-teal-600">Support Throughout</span>
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              We understand that dealing with a hoarder house is about more than just property - it's often tied to grief, family dynamics, mental health challenges, or overwhelming life circumstances. Our approach is rooted in compassion and respect for your unique situation.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              <strong className="text-gray-900">We never judge.</strong> Hoarding is a complex issue that affects people from all walks of life. Whether you're dealing with your own hoarding challenges, helping a family member, or managing an inherited property, we treat you with the dignity and respect you deserve.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Our team takes time to listen to your concerns, answer your questions, and work at a pace that feels comfortable for you. We're not here to rush you or pressure you into a decision - we're here to provide a solution when you're ready.
            </p>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-4">What Our Clients Say</h3>
              <div className="space-y-6">
                <div className="border-l-4 border-teal-600 pl-4">
                  <p className="text-gray-700 italic mb-2">
                    "I was so embarrassed about my mother's house, but the team at TREX RE LLC made me feel comfortable from the first phone call. They never made me feel judged and handled everything with such care and respect."
                  </p>
                  <p className="text-sm text-gray-600 font-semibold">- Sarah M.</p>
                </div>
                <div className="border-l-4 border-teal-600 pl-4">
                  <p className="text-gray-700 italic mb-2">
                    "After my father passed, I inherited his house which was filled with 40 years of belongings. I didn't know where to start. TREX RE LLC took care of everything and made a difficult time so much easier."
                  </p>
                  <p className="text-sm text-gray-600 font-semibold">- Michael T.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <img 
              src="https://public.readdy.ai/ai/img_res/e23ec0f61a70c9b1cdacfa95ab7bb3be.jpg"
              alt="Compassionate support and understanding"
              className="w-full h-80 object-cover rounded-xl shadow-lg"
            />
            
            <div className="bg-teal-600 rounded-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">Resources We Can Connect You With</h3>
              <p className="text-teal-50 mb-6 leading-relaxed">
                While we focus on purchasing your property, we can also connect you with helpful resources if needed:
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-heart-pulse-line text-xl mr-3 mt-1"></i>
                  <span>Mental health professionals specializing in hoarding disorder</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-group-line text-xl mr-3 mt-1"></i>
                  <span>Support groups for families affected by hoarding</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-hand-heart-line text-xl mr-3 mt-1"></i>
                  <span>Professional organizers trained in hoarding situations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-book-open-line text-xl mr-3 mt-1"></i>
                  <span>Educational resources about hoarding disorder</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
